// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"88b92b327ce2d8c83481","526":"b4e85dcdf181a6bfc7e7","777":"710b8a35c8478efdf14a","968":"f029b8215374d53afd5b"}[chunkId] + ".js";
};